import './DetailPanels.css';

export function DetailPanel({ title, body }) {
  return (
    <div className="detail-panel">
      <div className="panel-label">
        <span>{title}</span>
      </div>
      <p className="detail-panel__body">{body}</p>
    </div>
  );
}

export function ClaimsPanel({ claims }) {
  return (
    <div className="detail-panel">
      <div className="panel-label">
        <span>CLAIMS EXTRACTED</span>
        <span className="panel-label__sub">{claims.length} TOTAL</span>
      </div>
      {claims.length === 0 ? (
        <div className="claims-list__empty">No factual claims extracted from this image.</div>
      ) : (
        <ol className="claims-list">
          {claims.map((c, i) => (
            <li key={i} className="claims-list__item">
              <span className="claims-list__num">{String(i + 1).padStart(2, '0')}</span>
              <span>{c}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
